import { newDateFromUTC, newDateToUTC } from '@bc-library/common'

// DATA RECEIVED FOM API (FROM UTC)

// ARRAYS
export const afterReceiving = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
     return afterReceivingOne(object);
   })
  }
  else if(data.docs && data.count && Array.isArray(data.docs)){
    data.docs = data.docs.map((object:any) => {
      return afterReceivingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = afterReceivingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const afterReceivingOne = (object:any) => {
  if(typeof object == 'object'){
    return {
      ...object,
      dateImported: object.dateImported && newDateFromUTC(object.dateImported),
      accountingDate: object.accountingDate && newDateFromUTC(object.accountingDate),
      paidDate: object.paidDate && newDateFromUTC(object.paidDate),
    }
  }
  return object;
}

// OBJECT FIELDS




// DATA TO BE SENT TO API (TO UTC)

// ARRAYS
export const beforeSending = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
      return beforeSendingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = beforeSendingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const beforeSendingOne = (object:any) => {
  if(typeof object == 'object'){
    return {
      ...object,
      dateImported: object.dateImported && newDateToUTC(object.dateImported),
      accountingDate: object.accountingDate && newDateToUTC(object.accountingDate),
      paidDate: object.paidDate && newDateToUTC(object.paidDate),
    }
  } 
  return object;
}

// OBJECT FIELDS




